import {FC, useEffect} from 'react'
import {useLocation, useMatch} from 'react-router'
import clsx from 'clsx'
import {useLayout} from '../core'
import {DrawerComponent} from '../../assets/ts/components'
import {WithChildren} from '../../helpers'
import {useIsMobile} from '../../../app/shared/responsive'

const Content: FC<WithChildren> = ({children}) => {
  const {classes} = useLayout()
  const location = useLocation()
  const requireDrawer = useIsMobile()

  useEffect(() => {
    DrawerComponent.hideAll()
  }, [location])

  useEffect(() => {
    if (!requireDrawer) {
      DrawerComponent.hideAll()

      const elements = document.getElementsByClassName('drawer-overlay')
      while (elements.length > 0) {
        elements[0].parentNode?.removeChild(elements[0])
      }
    }

    DrawerComponent.reinitialization()
  }, [requireDrawer])

  const fieldListMatch = useMatch('/gis/field/list')
  const fieldDetailMatch = useMatch('/gis/field/view/:field_id')
  const landDetailMatch = useMatch('/gis/field/view/:field_id/land/view/:land_id')
  const landAmbientsMatch = useMatch('/gis/field/view/:field_id/land/view/:land_id/ambients')
  const landAmbientLayersMatch = useMatch(
    '/gis/field/view/:field_id/land/view/:land_id/ambients/layers'
  )
  const landComparisonMatch = useMatch('/gis/field/view/:field_id/land/view/:land_id/comparison')

  useEffect(() => {
    if (requireDrawer) {
      return
    }

    const paths = [
      fieldListMatch,
      fieldDetailMatch,
      landDetailMatch,
      landAmbientsMatch,
      landAmbientLayersMatch,
      landComparisonMatch,
    ]

    let itsTrue = false
    for (var i = 0; i < paths.length; i++) {
      if (paths[i] != null) {
        itsTrue = true
      }
    }

    if (!itsTrue) {
      return
    }
    setTimeout(() => {
      const right = DrawerComponent.getInstance('kt_right_container')
      if (right) {
        right.show()
      }
    }, 1000)
  }, [
    fieldDetailMatch,
    fieldListMatch,
    landAmbientLayersMatch,
    landAmbientsMatch,
    landComparisonMatch,
    landDetailMatch,
    requireDrawer,
  ])

  return (
    <div
      id='kt_content_container'
      style={{
        position: 'relative',
        height: 'auto',
        overflow: 'auto',
      }}
      className={'p-0 ' + clsx(classes.contentContainer.join(' '))}
    >
      {children}
    </div>
  )
}

export {Content}
